module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "index"
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-tip"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.fnToWebPage('https://qlinkcc.taobao.com/?qq-pf-to=pcqq.c2c')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-taobao"
  }), _vm._v("酷联商城")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.fnToRouter('/404')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-houtai"
  }), _vm._v("控制台")])]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t开启物联网时代，请\n\t\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.fnToRouter('/404')
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.fnToRouter('/404')
      }
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "header-menu"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": _vm.img.logo
    }
  }), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.fnMenu
    },
    model: {
      value: (_vm.sMenuSelected),
      callback: function($$v) {
        _vm.sMenuSelected = $$v
      },
      expression: "sMenuSelected"
    }
  }, [_vm._l((_vm.$store.state.aIndexMenu), function(item) {
    return [_c('el-tab-pane', {
      attrs: {
        "label": item.name,
        "name": item.path
      }
    })]
  })], 2)], 1)])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6787f588"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 787
// module chunks = 1